import { Link, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { MediaTips } from './components/MediaTips';
import { UploaderCropperForm } from './components/UploaderCropperForm';
import { useMedia } from './hooks/useMedia';

export const Media = () => {
	const { data, actions } = useMedia();
	return (
		<div className="container mx-auto mb-22 flex max-w-[620px] flex-col gap-6 px-5 py-8 md:gap-12" data-qa="media-step">
			<div className="grid gap-4">
				<Text as="h1" variant="heading" className="m-0">
					<Translate value="corgi.start_a_petition.media.heading" />
				</Text>

				<Text as="p" variant="body" size="medium">
					<Translate value="corgi.start_a_petition.media.description_paragraph" />{' '}
					<Link
						href={data.descriptionLinkHref}
						onClick={actions.descriptionLinkOnClick}
						data-qa="media-tips-link"
						preventScrollReset
					>
						<Translate value="corgi.start_a_petition.media.description_link_text" />
					</Link>
				</Text>
			</div>

			<UploaderCropperForm />
			<div id="media-tips">
				<MediaTips />
			</div>
		</div>
	);
};
